import type { LayersList } from "@deck.gl/core";
import type { GeoJSON } from "geojson";

import type { ViewportType } from "~/lib/map/types";
import { initAreaViewLayer } from "~/lib/map/utils";

import { useMapBase } from "./useMapBase";

type useMapProps = {
  width: number;
  height: number;
  areaH3Indexes: string[];
  geometry: GeoJSON | null;
  initialViewState?: Partial<ViewportType>;
};

export const useViewMap = ({ width, height, areaH3Indexes, geometry, initialViewState }: useMapProps) => {
  const { viewState, onViewStateChange } = useMapBase({
    width,
    height,
    areaH3Indexes,
    geometry,
    initialViewState,
  });

  const layers: LayersList = [initAreaViewLayer(areaH3Indexes, geometry)];

  return { layers, viewState, onViewStateChange };
};
